<template>
  <div class="home">
    <div class="sizeme">
      <p>
        Mo’s vehicle transport is based in Reading, Berkshire but we also service other areas such as
        Hampshire, Surrey, Buckinghamshire and more.
      </p>
      <p>
        We provide local and nationwide transportation; <b>no job is too close or too far.</b>
      </p>
      <p>
        <b>We pride ourselves on being friendly, reliable with value for money.</b>
      </p>
      <p>
        We specialise in transporting a wide range of vehicles from small cars all the way to commercial
        vehicles, with a max weight of 2600kg; and as long as it fits safely and securely on our trailer,
        then we can transport it.
      </p>
      <p>
        What we offer to our customers:
      </p>
      <p><b>Auction collection and delivery</b></p>
      <p><b>Classic car collection and delivery</b></p>
      <p><b>Bodyshop/workshop collection and delivery</b></p>
      <p><b>Dealership transfer</b></p>
      <p><b>Imported vehicle collection & delivery from UK ports</b></p>
      <p><b>Private customers door to door car transport services</b></p>
      <p><b>Owners clubs for show car transport</b></p>
      <p><b>Towing service</b></p>
      <p>
        If you interested in one of our service or have any questions,
        please get in contact with us or fill out our easy online Quote form.
      </p>
      <p>
        We are here to help you with your transportation needs!
      </p>
    </div>
    <div class="button-spacing">
      <button
        id="getQuote"
        class="button-icon"
        v-on:click="slideQuote"
      >Get Quote!
      </button>
      <button
        id="contactUs"
        class="button-icon"
        v-on:click="slideContact"
      >Contact Us
      </button>
    </div>
    <quote-form id='quote' v-if="quoteClick"/>
    <contact-form id='contact' v-if="contactClick"/>
    <!-- <p><b>This is what our customers say about us!</b></p>
    <review-view :reviews="listReviews" :maxFive="true"/>
    <div class="sizeme">
      <button
        id="getReview"
        class="button-icon"
        v-on:click="reviewPage()"
      >View More
      </button>
      <p><b>Some of the stuff we have moves for our customers!</b></p>
    </div> -->
    <image-slider v-if="mobileView" :listImages="gallery"/>
    <image-wall v-if="!mobileView" v-bind:list-images="gallery"/>
  </div>
</template>

<script>
import db from '../../config/db'
import { getImages } from '../store/helper.js'
import QuoteForm from '../components/forms/quoteForm.vue'
// import reviewView from '../components/review/reviewView.vue'
import ContactForm from '../components/forms/contactForm.vue'
import ImageWall from '../components/images/ImageWall.vue'
import ImageSlider from '../components/images/ImageSlider.vue'

export default {
  name: 'Home',
  components: {
    // reviewView,
    ImageWall,
    ImageSlider,
    QuoteForm,
    ContactForm
  },
  data () {
    return {
      gallery: [],
      listReviews: [],
      mobileView: true,
      quoteClick: false,
      contactClick: false
    }
  },
  mounted () {
    this.getGallery()
  },
  created () {
    this.getReviews()
    this.getGallery()
    this.handleView()
    window.addEventListener('resize', this.handleView)
  },
  methods: {
    reviewPage () {
      this.$router.push(
        { name: 'Testimony' }
      ).catch(() => {})
    },
    slideQuote () {
      if (this.quoteClick === false) {
        this.quoteClick = true
        this.contactClick = false
        setTimeout(
          function () {
            document.getElementById('quote').scrollIntoView({ behavior: 'smooth' })
          }, 500
        )
      } else if (this.quoteClick === true) {
        this.quoteClick = false
      }
    },
    slideContact () {
      if (this.contactClick === false) {
        this.contactClick = true
        this.quoteClick = false
        setTimeout(
          function () {
            document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })
          }, 500
        )
      } else if (this.contactClick === true) {
        this.contactClick = false
      }
    },
    handleView () {
      this.mobileView = window.innerWidth <= 500
    },
    getGallery () {
      const vm = this
      vm.gallery = getImages('gallery')
    },
    getReviews () {
      const vm = this
      let reviews = []
      let data = {}
      db.firestore.collection('reviews')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // Using image name to obtain image url
            db.storing.ref('images')
              .child(doc.data().image)
              .getDownloadURL()
              .then((downloadURL) => {
                data = {
                  id: doc.id,
                  name: doc.data().name,
                  image: downloadURL,
                  rating: doc.data().rating,
                  more: doc.data().more,
                  date: doc.data().date
                }
                reviews.push(data)
                reviews = reviews.sort(
                  (a, b) => b.date - a.date
                )
              })
          })
        })

      vm.listReviews = reviews
    }
  }
}
</script>

<style lang="scss">
@import "../assets/common.scss";

.sizeme {
  width: 85%;
  margin: auto;
}

.imageborder {
  box-sizing: border-box;
  border: 1px solid #2c3e50;
}

body {
  background: #fff;
  padding-bottom: 5px;
  @media (max-width: 760px) {
    margin: 0;
    padding-bottom: 75px;
  }
}

a {
    text-decoration: none;
    color: $content-colour;
  }

.button-spacing {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;

  @media (min-width: 760px) {
    width: 60%;
  }
}

</style>
